var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgResetWhite = function SvgResetWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "var(--button-primary-background-color)",
    width: 26,
    height: 26,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.57 7.694A.977.977 0 1 0 8.243 6.26l-2.93 2.705a.977.977 0 0 0 0 1.435l2.93 2.705A.977.977 0 1 0 9.57 11.67l-1.094-1.01h7.32a3.531 3.531 0 0 1 0 7.062H9.883a.977.977 0 1 0 0 1.953h5.91a5.485 5.485 0 0 0 0-10.97h-7.32l1.095-1.01Z",
    fill: "var(--white)",
    fillRule: "nonzero"
  }))));
};
export default SvgResetWhite;